import { useModal } from '@ebay/nice-modal-react'
import { useNavigate } from '@tanstack/router'

import useCommonEmblaCarousel from '../../hooks/useCommonEmblaCarousel'
import useGeoCheck from '../../hooks/useGeoCheck'
import { useBoundStore } from '../../store/store'
import type { Game } from '../../types/game'
import LogInModal from '../common/log-in-modal'
import Icon from '../icon'
import { Button } from './sliderStyles'

type CasinoSliderProps = {
  slots: Game[]
}

const CasinoSlider = ({ slots }: CasinoSliderProps) => {
  const [emblaRef] = useCommonEmblaCarousel()
  const username = useBoundStore(state => state.user.username)
  const navigate = useNavigate({ from: '/' })
  const { geoCheck } = useGeoCheck()
  const logInModal = useModal(LogInModal)

  return (
    <>
      <div className="embla" ref={emblaRef}>
        <div className="embla__container -ml-[10px] lg:-ml-5">
          {slots.map(game => (
            <div
              key={game.gameInfo.gameCode}
              className="pl-[10px] flex-[0_0_50%] lg:pl-5 lg:flex-[0_0_20%]">
              <div className="relative flex-1 bg-white flex p-1 rounded-[25px]">
                <img
                  src={game.imgURL}
                  style={{ aspectRatio: '1' }}
                  alt={game.name}
                  className="w-full h-full object-cover rounded-[25px]"
                />
                <Button
                  onClick={() => {
                    if (!username) {
                      return geoCheck(logInModal.show)
                    }
                    navigate({
                      to: '/casino/$category',
                      params: { category: 'slots' },
                    })
                  }}>
                  <Icon id="arrow-right" width="12" height="11" fill="#000" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default CasinoSlider
